(function () {
    "use strict";

    angular.module("app").component("dossierUser", {
        bindings: {
            user: "="
        },
        template: `
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2">
                <label i18n="Person_FirstName"></label>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6">
                {{$ctrl.user.FirstName}}
            </div>
        </div>
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2">
                <label i18n="Person_Name"></label>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6">
                {{$ctrl.user.LastName}}
            </div>
        </div>
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2">
                <label i18n="Person_Email"></label>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6">
                {{$ctrl.user.Email}}
            </div>
        </div>
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2">
                <label i18n="Person_Phone"></label>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6">
                {{$ctrl.user.Phone}}
            </div>
        </div>`
    });
})();